module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Medium.07678d11.woff";